import React from "react";
import styles from "./LawyerCard.module.scss";
import LawyerAvatar from "../../../assets/img/lawyerAvatar.png";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";

const LawyerCard = (props) => {
  return (
    <>
      {props.lawyer && (
        <div className={styles.LawyerCard}>
          {props.imageUrl && (
            <img
              src={props.imageUrl}
              alt={props.subtitle}
              className={styles.avatar}
            />
          )}
          {!props.imageUrl && (
            <div className={styles.noAvatar}>
              <PersonRoundedIcon />
            </div>
          )}
          <div className={styles.content}>
            <div className={styles.name}>
              {props.lawyer.name && props.lawyer.name}{" "}
              {props.lawyer.surname && props.lawyer.surname}
            </div>

            {props.lawyer.lawyerStatus && (
              <div className={styles.status}>{props.lawyer.lawyerStatus}</div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

LawyerCard.defaultProps = {};

export default LawyerCard;
